import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ContainersService } from 'src/app/providers/services/containers.service';
import { ContainerMission } from 'src/app/storage/models/container-mission.model';
import { Container } from 'src/app/storage/models/container.model';
import { Mission } from 'src/app/storage/models/mission.model';

@Component({
    selector: 'app-add-container',
    templateUrl: './add-container.component.html',
    styleUrls: ['./add-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddContainerComponent implements OnInit {

  containers: Container[] = [];
  displayedContainers: Container[] = [];

  @Input() mission: Mission;
  @Input() missionContainers: ContainerMission[];
  @Output() closeModal = new EventEmitter<any>();

  constructor(
    private containersService: ContainersService
  ) { }

  async ngOnInit(): Promise<void> {
    // Fetch containers to display as selection options
    const containers = await this.containersService.getContainers(this.mission.marketname, this.mission.missionId);
    !!(containers) ?
      this.setContainers(containers) :
      this.close();
  }

  close(): void {
    this.closeModal.emit();
  }

  setContainers(containers: Container[]): void {
    this.containers = containers
      // Order containers by attributes
      .sort((a, b) => { return a.containerId > b.containerId ? 1 : -1; })
      // Remove deactivated containers
      .filter(container => container.isActivated)
      // Remove selected containers
      .filter(container => this.missionContainers.find(missionContainer => container.containerpk === missionContainer.containerpk) === undefined);

    this.displayedContainers = this.containers;
  }

  filterContainers($event): void {
    const value = $event.target.value;

    this.displayedContainers = this.containers.filter(container => {
      // List attribute to filter on
      const attributesToFilterOn = [
        container.containerId,
        container.transportcompanyName
      ];

      // Find at least one attribute that checks the criterion
      return attributesToFilterOn.find(attribute =>
        attribute.toUpperCase().includes(value.toUpperCase())
      ) != null;
    });
  }

  getCompanyLogo(transportcompanyName: string) {
    let logo = 'unknown-logo.svg';
    const transportcompany = Object.keys(CONSTANTS.LOGOS).find(logo => logo === transportcompanyName);
    if (transportcompany != null) { logo = CONSTANTS.LOGOS[transportcompany]; }

    return `assets/logos/${logo}`;
  }

  addContainer(container: Container): void {
    this.closeModal.emit(container);
  }

}
